import React, { useEffect, useState } from 'react';
import { Button } from '@mui/material';
import MoneyBackGuarantee from '../MoneyBackGuarantee';
import { useStore } from "../SmartEditor/lib/states"

const modes = {
  pro: "Pro",
  basic: "Basic"
}

const ComposeSection = ({ userData, onShowPricing, defaultMode, t, currentLanguage }) => {

  const [loading, setLoading] = useState(false);
  const [mode, setMode] = useState(defaultMode);
  const [
    settings
  ] = useStore((state) => [
    state.settings,
  ])

  return (
    <>
      <main>
        <div className="progress-area">
          <div className="flex space-between w-100p">
            <strong>{t('app.menu.creditTitle')}</strong>
            <div className="flex items-center mb-0">
              <span style={{marginRight: "2px", marginTop: "-2px"}}>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 32 32" fill="#ffc337"><path d="M17.333 4v9.333h8L14.666 28v-9.333H6.667z"/></svg>
              </span>
              {/* {mode === modes.pro ?
                <span className="text-white">{userData.proCredits?.toFixed(0)}</span>
                :
                <span className="text-white">{userData.basicCredits?.toFixed(0)}</span>
              } */}
              {mode === modes.pro ?
                <span className="text-white">{settings.credits?.toFixed(0)}</span>
                :
                <span className="text-white">{settings.credits?.toFixed(0)}</span>
              }
            </div>
          </div>
          {/* <div className="mt-2">
            <MoneyBackGuarantee/>
          </div> */}
          <Button 
            className="upgrade-button mt-4"
            onClick={() => onShowPricing(true)}
            type="submit"
            loading={loading}
            // variant="contained"
            sx={{
              backgroundColor: 'inherit',
              color: 'white',
              '&:hover': {
                backgroundColor: '#000',
              },
              '&:disabled': {
                backgroundColor: '#ffa5c0',
                color: 'white',
              },
              textTransform: 'none',
              // padding: '8px 16px',
              fontSize: '14px',
              width: '100%'
            }}
          >
            {t('button.upgrade')}
          </Button>
        </div>
      </main>
    </>
  )
}

export default ComposeSection
